import { Compass } from 'lucide-react';
import type { NavItem } from './types';

/**
 * The menu's first destination, above «Inicio» (the dashboard) and deliberately so: it is
 * what has to be read on day one, before any metrics dashboard.
 *
 * A compass and not a house: «Empezar aquí» orients, it is not a home. The home
 * icon is already used by «Inicio».
 */
export const getStartedNav: readonly NavItem[] = [
  { label: 'Empezar aquí', to: '/get-started', icon: Compass, group: 'setup' },
];
